import { api, etagOf, type S } from "@/shared/api/client";
import { pick } from "@/shared/ui/ResourceForm";

/** The company's settings, as its page saves them. */
export const COMPANY_KEYS = ["legal_name_ar", "legal_name_en", "country", "tax_number", "commercial_register", "email", "base_currency", "currencies", "fiscal_year_start_month", "timezone", "weekend_days", "address", "custom"];

/** Saves some of the company's settings and keeps the rest. */
export async function saveCompany(id: string, patch: Record<string, unknown>) {
  const c = await api.get<S["Company"]>(`/v1/core/companies/${id}`);
  await api.put(`/v1/core/companies/${id}`, { ...pick(c, COMPANY_KEYS), ...patch }, etagOf(c));
}

/** Saves the company's tax number and keeps the rest of its settings. */
export function saveCompanyTaxNumber(id: string, taxNumber: string) {
  return saveCompany(id, { tax_number: taxNumber });
}
